enum PageKey {
  CvMakerBuild,
}

export default class SessionStorage {
  static readonly PageKey = PageKey;

  public static loadState(
    defaults: object = {},
    key: PageKey = PageKey.CvMakerBuild,
  ): any {
    try {
      const raw = sessionStorage.getItem(key.toString());
      return raw ? { ...defaults, ...JSON.parse(raw) } : defaults;
    } catch {
      return defaults;
    }
  }

  public static saveState(
    state: object | any,
    key: PageKey = PageKey.CvMakerBuild,
  ): void {
    try {
      sessionStorage.setItem(key.toString(), JSON.stringify(state));
    } catch {
      //
    }
  }

  public static removeState(key: PageKey = PageKey.CvMakerBuild): void {
    sessionStorage.removeItem(key.toString());
  }
}
